{
  "zh-TW": {
    "baseChip": {
      "states": {
        "included": "已包含",
        "excluded": "已排除"
      },
      "sortHint": "使用方向鍵移動"
    }
  }
}
